/**
 * Settings › Classification, held in the URL like the question bank's scope.
 *
 * Without a scope the page is an overview: one card per type. With one
 * (`?scope=content`, `?scope=type:<id>`) it manages that type; the
 * breadcrumb leads back to the cards. There is no secondary panel.
 */

export type BuiltInScope = "content" | "standards" | "bloom" | "difficulty"
/** A built-in type, or `type:<id>` for one the admin added. */
export type ClassificationScope = BuiltInScope | `type:${string}`

const BUILT_IN: readonly BuiltInScope[] = ["content", "standards", "bloom", "difficulty"]

/** The type being managed, or null on the overview. */
export function classificationScopeOf(search: string | URLSearchParams): ClassificationScope | null {
  const params = typeof search === "string" ? new URLSearchParams(search) : search
  const scope = params.get("scope")
  if (!scope) return null
  if (BUILT_IN.includes(scope as BuiltInScope)) return scope as BuiltInScope
  return scope.startsWith("type:") && scope.length > 5 ? (scope as `type:${string}`) : null
}

export function classificationHref(scope: ClassificationScope): string {
  return `/exam-management/settings/categories?scope=${encodeURIComponent(scope)}`
}

export function classificationOverviewHref(): string {
  return "/exam-management/settings/categories"
}

export function customTypeIdOf(scope: ClassificationScope | null): string | null {
  return scope && scope.startsWith("type:") ? scope.slice(5) : null
}
